import { useNavigate } from "react-router-dom";
import MainContainer from "../../../layout/MainContainer";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  IconButton,
  Button,
} from "@mui/material";
import SearchBar from "../../../components/SearchBar";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useLazyGetMoodsQuery } from "../../../services/moods";
import { isValidInput } from "../../../utils/validations";
import usePermission from "../../../hooks/usePermission";

const MoodMapping = () => {
  const navigate = useNavigate();

  // Permission hook for AI Behavior Language module
  const { 
    hasPermission, 
    isLoading: permissionLoading, 
    canView, 
    canAddEdit, 
    canDelete 
  } = usePermission({
    module: "AI Behavior Language",
    permission_type: "can_view"
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [getUser] = useLazyGetMoodsQuery();

  const getUserList = async () => {
    setIsLoading(true);
    try {
      const response = await getUser({
        length: 10,
        start: page,
        search: debouncedSearchTerm,
      }).unwrap();
      if (response.status === 200) {
        setData(response?.data?.response_object || []);
        setTotalCount(response?.data?.total_records || 0);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getUserList();
  }, [debouncedSearchTerm, page]);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);
    return () => clearTimeout(timerId);
  }, [searchTerm]);

  // Show loading while checking permissions
  if (permissionLoading) {
    return <div>Loading permissions...</div>;
  }

  // Show access denied if user doesn't have view permission
  if (!hasPermission) {
    return <div>Access Denied</div>;
  }

  return (
    <>
      <div className="main_title">
        <h1>Emotional AI & Mood Mapping</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Mood
          Mapping
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            {/* <Box className="search_box">
              <SearchBar
                placeholder="Search..."
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box> */}
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow hover>
                <TableCell>Mood</TableCell>
                <TableCell>Reflection Prompt</TableCell>
                {canAddEdit("AI Behavior Language") && (
                  <TableCell>Actions</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row: any) => (
                <TableRow hover key={row.id}>
                  <TableCell style={{ fontSize: "24px" }}>
                    {row?.mood_image?.media_file_url ? (
                      <img
                        src={row.mood_image.media_file_url}
                        alt={row?.mood_name || row?.mood_type}
                        style={{
                          width: 32,
                          height: 32,
                          borderRadius: 4,
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      row?.mood_name || row?.mood_type || "-"
                    )}
                  </TableCell>
                  <TableCell>{row?.reflection_prompt || "-"}</TableCell>
                  {canAddEdit("AI Behavior Language") && (
                    <TableCell>
                      <div className="table_actions v2">
                        <Box>
                          <IconButton
                            onClick={() =>
                              navigate(`/mood-mapping/add-mood-map?id=${row.id}`)
                            }
                          >
                            <img src="/static/images/edit2_icon.svg" alt="Edit" />
                          </IconButton>
                        </Box>
                      </div>
                    </TableCell>
                  )}
                </TableRow>
              ))}
              {!isLoading && data.length === 0 && (
                <TableRow>
                  <TableCell colSpan={canAddEdit("AI Behavior Language") ? 3 : 2} style={{ textAlign: "center", padding: "24px" }}>
                    No data available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default MoodMapping;
